export const programOptions = [
  {
    label: 'Full Year',
    value: 'Full Year',
  },
  {
    label: 'First Semester',
    value: 'First Semester',
  },
  {
    label: 'Second Semester',
    value: 'Second Semester',
  },
];
